export default function isPostDateLessThan30Days(date) {
    let now = new Date().getTime();
    let timestamp = now - (30 * 24 * 60 * 60 * 1000);

    return new Date(date).getTime() > timestamp;
  }